import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { BitsoBank } from '@/types/bitsoBank';
import { PaymentRailType } from '@/types/currency';
import { RecipientResponse } from '@/types/recipient';

interface Props {
  readonly recipient: RecipientResponse;
  readonly banks: readonly BitsoBank[];
}

export const RecipientTransactionDetailsItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { recipient, banks } = props;
  const tr = useTranslator();
  const { details, type, currency } = recipient;
  const name = recipient.individualName ?? recipient.businessName ?? '';

  const getSubtitle = (): string => {
    switch (type) {
      case PaymentRailType.ACH:
      case PaymentRailType.Wire:
        return [currency, tr((details.bankName as string) ?? '')]
          .filter((v: string): boolean => v !== '')
          .join(separator);
      case PaymentRailType.Swift:
        return [currency, tr((details.bankName as string) ?? '')]
          .filter((v: string): boolean => v !== '')
          .join(separator);
      case PaymentRailType.PIX:
        return [currency, (details.pixKey as string) ?? '']
          .filter((v: string): boolean => v !== '')
          .join(separator);
      case PaymentRailType.SPEI:
        return [currency, (details.clabe as string) ?? '']
          .filter((v: string): boolean => v !== '')
          .join(separator);
      case PaymentRailType.COP: {
        const bank = banks.find((b: BitsoBank): boolean => b.code === (details.bankCode as string));
        return [currency, tr(bank?.name ?? '')]
          .filter((v: string): boolean => v !== '')
          .join(separator);
      }
      case PaymentRailType.CVU:
        return [currency, (details.cvu as string) ?? '']
          .filter((v: string): boolean => v !== '')
          .join(separator);
      default:
        return '';
    }
  };

  return (
    <Box>
      <Typography variant="body2" color="text.primary">
        {tr(name)}
      </Typography>
      <Typography
        variant="body2"
        color="custom.LightGray"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis">
        {getSubtitle()}
      </Typography>
    </Box>
  );
};

const separator = ' | ';
